import { create } from 'zustand';
import { api } from '../api/client';

interface EntityRef {
  type: string;
  value: string;
  sellerId?: number;
}

interface EntityState {
  isOpen: boolean;
  entity: any | null;
  loading: boolean;
  error: string | null;
  history: EntityRef[];
  current: EntityRef | null;
  open: (ref: EntityRef) => void;
  close: () => void;
  goBack: () => void;
}

export const useEntityStore = create<EntityState>((set, get) => ({
  isOpen: false,
  entity: null,
  loading: false,
  error: null,
  history: [],
  current: null,

  open: async (ref: EntityRef) => {
    const { current, history } = get();
    const newHistory = current ? [...history, current].slice(-20) : history;

    set({ isOpen: true, loading: true, error: null, current: ref, history: newHistory });

    try {
      const sellerId = ref.sellerId || 1;
      const res = await api.get<any>(`/entity/lookup?type=${ref.type}&value=${encodeURIComponent(ref.value)}&seller_id=${sellerId}`);
      if (res.success) {
        set({ entity: res as any, loading: false });
      } else {
        set({ error: (res as any).error || 'Lookup failed', loading: false });
      }
    } catch (err: any) {
      set({ error: err.message || 'Lookup failed', loading: false });
    }
  },

  close: () => set({ isOpen: false, entity: null, history: [], current: null, error: null }),

  goBack: () => {
    const { history } = get();
    if (history.length === 0) {
      set({ isOpen: false, entity: null, current: null });
      return;
    }
    const prev = history[history.length - 1];
    const newHistory = history.slice(0, -1);
    set({ history: newHistory, current: prev, loading: true, error: null });

    const sellerId = prev.sellerId || 1;
    api.get<any>(`/entity/lookup?type=${prev.type}&value=${encodeURIComponent(prev.value)}&seller_id=${sellerId}`)
      .then(res => {
        if (res.success) set({ entity: res as any, loading: false });
        else set({ error: (res as any).error || 'Lookup failed', loading: false });
      })
      .catch(err => set({ error: err.message, loading: false }));
  },
}));
